var _defs, _g, _line, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spar-wide-logo_navy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 222.84,
    height: 30.359,
    viewBox: "0 0 222.84 30.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 144.565,
    height: 30.202,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M218.05,346.411q2.251,1.922,6.758,1.921a10.8,10.8,0,0,0,6.759-1.854,6.842,6.842,0,0,0,2.384-5.566,6.166,6.166,0,0,0-.729-3.05,5.342,5.342,0,0,0-2.23-2.131,9.66,9.66,0,0,0-1.735-.67c-.813-.248-4.854-1.35-5.263-1.46-2.252-.548-3.682-1.3-3.693-2.631.117-2.576,2.518-2.782,3.844-2.782a5.447,5.447,0,0,1,3.247.862,2.985,2.985,0,0,1,1.267,2.521h4.5a7.362,7.362,0,0,0-2.385-5.37,9.363,9.363,0,0,0-6.229-1.855q-4.308,0-6.559,1.789a6.252,6.252,0,0,0-2.252,5.1,5.858,5.858,0,0,0,2.517,5.169,15.782,15.782,0,0,0,4.506,1.525l1.791.391c3.107.757,4.89,1.717,4.834,3.254a2.487,2.487,0,0,1-1.06,2.12,5.717,5.717,0,0,1-3.113.73,6.261,6.261,0,0,1-3.645-.929,3.639,3.639,0,0,1-1.525-2.783H215.4a7.326,7.326,0,0,0,2.65,5.7",
    transform: "translate(-215.4 -324.347)",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M244.516,338.536c0-1.731-.317-5.394-3.861-5.394-3.365,0-3.729,3.574-3.729,5.394,0,4.608,2.619,5.194,3.862,5.194,3.218,0,3.728-3.415,3.728-5.194m-7.589,13.051a2.246,2.246,0,0,1-2.263,2.263H232.4v-16.58c.262-4.412,1.867-7.927,8.567-8.167a8.145,8.145,0,0,1,6.244,2.642,10.37,10.37,0,0,1,1.9,6.59,10.832,10.832,0,0,1-2,6.79,6.24,6.24,0,0,1-5.128,2.531,8.167,8.167,0,0,1-5.063-1.549c0,.151,0,5.476,0,5.476",
    transform: "translate(-212.9 -323.65)",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M256.162,343.669c-1.147-.058-3.333-.283-3.534-4.108h11.481c0-.117,0-1.376,0-1.378a10.364,10.364,0,0,0-2.12-6.641,7.941,7.941,0,0,0-6.163-2.385,7.382,7.382,0,0,0-5.9,2.451,9.825,9.825,0,0,0-2.054,6.626q0,4.44,2.12,6.825a7.373,7.373,0,0,0,5.895,2.452,8.43,8.43,0,0,0,5.169-1.525,7.249,7.249,0,0,0,2.789-4.246h-3.989c-.588,1.665-2.088,2.008-3.7,1.926m-.2-10.668c2.847-.038,3.289,2.385,3.379,3.578h-6.757s-.057-3.514,3.379-3.578",
    transform: "translate(-210.613 -323.637)",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M274.551,341.752h4.355a7.607,7.607,0,0,1-7.762,5.763c-6.579,0-8.2-5.28-8.2-8.749s.616-9.395,7.942-9.6a7.5,7.5,0,0,1,7.885,5.763h-4.636s-.45-1.983-3.21-1.92-3.481,2.654-3.481,5.117.613,5.547,3.677,5.547c2.914.088,3.171-1.487,3.428-1.921",
    transform: "translate(-208.393 -323.641)",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M282.343,334.883h2.724v-4.644h-2.716v-2.981A2.126,2.126,0,0,0,280.164,325h-2.386v19.48c0,2.032.786,3.247,2.493,3.247h2.073Z",
    transform: "translate(-206.209 -324.254)",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M288.958,347.1v-9.077a3.984,3.984,0,0,1,.927-2.915,3.876,3.876,0,0,1,2.849-.927h1.525v-4.705a16.055,16.055,0,0,0-4.141.465,8.708,8.708,0,0,0-2.949,1.457,7.159,7.159,0,0,0-2.087,2.816,10.912,10.912,0,0,0-.762,4.34V347.1Z",
    transform: "translate(-205.247 -323.593)",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M294.124,329.5h4.639v11.264a2.857,2.857,0,0,0,3.047,3.05,2.9,2.9,0,0,0,3.111-2.919v-9.208s.157-2.186,2.168-2.186H309.5s0,10.362,0,10.461c-.032.57.608,7.5-7.685,7.47-8.216,0-7.633-7.009-7.686-7.422Z",
    transform: "translate(-203.801 -323.586)",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M324.1,347.219h-4.595V335.9a2.806,2.806,0,0,0-3.131-3.063,2.874,2.874,0,0,0-3.061,3.063v11.32h-4.663V336.831c0-3.018.9-4.86,2.365-6.059a8.708,8.708,0,0,1,5.226-1.665,13.5,13.5,0,0,1,3,.334,6.313,6.313,0,0,1,2.664,1.332,5.9,5.9,0,0,1,2.364-1.232,11.2,11.2,0,0,1,2.83-.432c5.685-.03,7.967,2.573,8.156,3.409v14.7h-2.631a2.23,2.23,0,0,1-2.263-2.263V335.9c.011-1.284-.438-3.063-3.131-3.063A2.865,2.865,0,0,0,324.1,335.9Z",
    transform: "translate(-201.66 -323.652)",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M332.965,332.068v14.69l9.678-7.344Z",
    transform: "translate(-198.078 -323.213)",
    fill: "#0099d8"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 29.877,
    transform: "translate(154.202 0.482)",
    fill: "none",
    stroke: "#083057",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Authorized_RESELLER",
    "data-name": "Authorized RESELLER",
    transform: "translate(163.84 12.782)",
    fill: "#003057",
    fontSize: 9,
    fontFamily: "Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AUTHORIZED"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "RESELLER"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4dc8244b004d995b7e0355e126c41da9.svg";
export { ForwardRef as ReactComponent };